/*
 * @Description: 路由配置
 * @Date: 2022-10-26 17:43:00
 * @Author: liangrongzhi
 * @LastEditors: zoushikun
 */

import { lazy } from 'react'
import { useRoutes, Navigate } from 'react-router-dom'
import { getSid, getToken, queryParams, formatSearch } from '@/utils'
import WrapperRouteComponent from './config'

// 页面组件
const Home = lazy(() => import('../pages/Home'))
const NewHome = lazy(() => import('../pages/NewHome'))
const MobileHome = lazy(() => import('../pages/MobileHome'))
const NewMobileHome = lazy(() => import('../pages/NewMobileHome'))
const MCP = lazy(() => import('../pages/MCP'))
const NotFound = lazy(() => import('../pages/NotFound'))

const setNavigateUrl = url => {
  const search = formatSearch(window.location.search)
  const sid = getSid()
  if (sid) {
    return `${url}?${queryParams({
      sid: sid,
      ...search
    })}`
  }
  // const token = getToken()
  // if (token) {
  //   return `${url}?${queryParams({
  //     token: token,
  //     ...search
  //   })}`
  // }
  return `${url}?${queryParams({
    ...search
  })}`
}

const routeList = [
  {
    path: '/',
    element: <Navigate to="/index" />
  },
  {
    path: '/home',
    element: <WrapperRouteComponent element={<Home />} />
  },
  {
    path: '/mobile/home',
    element: <WrapperRouteComponent element={<MobileHome />} />
  },
  // 新版首页
  {
    path: '/index',
    element: <WrapperRouteComponent element={<NewHome />} />
  },
  {
    path: '/mobile/index',
    element: <WrapperRouteComponent element={<NewMobileHome />} />
  },
  {
    path: '/mcp',
    element: <WrapperRouteComponent element={<MCP />} />
  },
  {
    path: '*',
    element: <NotFound />
  }
  // {
  //   path: '/userFeedback',
  //   element: <WrapperRouteComponent element={<UserFeedback />} />
  // },
]

const RenderRouter = () => {
  return useRoutes(routeList)
}

export default RenderRouter
